(function () {
    'use strict';

    angular
        .module('app')
        .component('temaFormAdmin', {
            templateUrl: 'app/components/auladigital/admin/tema/tema-form.admin.html',
            controller: Controller,
            controllerAs: 'ctrl',
            bindings: {
                item: '<',
                previousParams: '<',
                materias: '<'
            }
        });

    /* @ngInject */
    function Controller($rootScope, $timeout, $state, $stateParams, ModalService) {
        var vm = this;

        $timeout(function () {
            angular.element('.form-group:eq(0) input').focus();
        });

        vm.mode = $state.current.data.mode;
        vm.canSave = vm.mode === 'create' || vm.mode === 'edit';

        function init() {
            if (!vm.item.materia) {
                vm.item.materia = {id: $stateParams.materiaid};
            }
        }

        // Guardar formulario
        vm.save = function () {
            vm.item.$save().then(function () {
                ModalService.closeComponent(vm.item, 'admin/aulaDigital/tema/list', vm.previousParams);
            }).catch(function (response) {
                $rootScope.mostrarErrores(response, vm.form);
            });
        };

        init();

    }

})();
